import {Application} from "@/models/Application";

export class ProtocolLineParent {
  constructor() {
    this.list = []
  }

  addProtocolLine(item) {
    this.list.push(ProtocolLine.buildFromAPI(item))
  }

  updateProtocolLine(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, ProtocolLine.buildFromAPI(item))
  }

  removeProtocolLine(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => ProtocolLine.buildFromAPI(el))
    }
    return this
  }
}

export class ProtocolLine {
  constructor() {
    this.id = null
    this.application = new Application()
    this.protocol = null
    this.decision = null
  }

  getForAPI() {
    return {
      id: this.id,
      application: this.application,
      protocol: this.protocol,
      decision: this.decision,
    }
  }

  getForShortAPI() {
    return {
      id: this.id,
      application: { id: this.application.id },
      protocol: this.protocol,
      decision: this.decision,
    }
  }

  static buildFromAPI(obj) {
    const _this = new ProtocolLine()
    if (obj) {
      _this.id = obj.id
      _this.application = obj && obj?.application ? Application.build(obj.application) : new Application()
      _this.protocol = obj.protocol
      _this.decision = obj.decision
    }
    return _this
  }
}